<template>
  <el-dialog :title="`${$i18.language('定义条件：')}${title}`" class="country-dialog el-body-contry-dialog" :modal-append-to-body="false" :close-on-click-modal="false" :append-to-body="true" :visible.sync="dialogVisible">
    <!-- 如果是关键词则出现AI拓词 -->
    <AIExploit :showOperation="false" :params="params" :productDescriptions="selected" v-show="keyName==='productDescriptions'" ref="AIExploit" @changeState="changeAIExploit"></AIExploit>
    <!-- 添加项 -->
    <p class="input-more-title">{{title}}</p>
    
    <div class="input-more-box">
      <div v-for="(item, index) in selected" class="whole input-more-item">
        <el-select :popper-append-to-body="false" popper-class="select customer-select" class="item-select" ref="closeSelect2" v-model="item.type" placeholder="">
          <el-option label="OR" :value="'or'"></el-option>
          <el-option label="AND" :value="'and'"></el-option>
          <el-option label="NOT" :value="'not'"></el-option>
        </el-select>
        <el-input :placeholder="$i18.language('值')" @blur="handleBlur(item, index)" @keyup.enter.native="handleBlur(item, index)" :maxlength="100" v-model="item.value" class="input-with-select">
        </el-input>
        <i class="el-icon-close more-dialog-close-button" @click="handleDeleteData(item, index)"></i>
      </div>
      <el-button class="more-dialog-add-button" @click="handleAddData">{{$t('addTo')}}</el-button>
    </div>
    <!-- 回显内容 -->
    <p class="search-value-desc" v-if="checkData.length==0">{{$i18.language('未输入条件')}}</p>
    <p class="search-value-desc" v-else>{{$i18.language('所选项目和条件')}}({{checkData.length}})</p>
    <div class="more-bottom-value">
      <multi-input-tag v-model="checkData" 
        :showPreciseQuery="showPreciseQuery" 
        :preciseQuery="preciseQueryValue" 
        @update:tags="handleChangeTags"
        @update:preciseQuery="handleChangePrecise"
        class="show-more-value" :readOnly="true" :showMoreButton="false" ref="MultiInputTagMore"></multi-input-tag>
      <i class="el-icon-close more-dialog-close-button" @click="deleteAll"></i>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="sub-confirm-btn" @click="close">{{$t('cancel')}}</el-button>
      <el-button class="confirm-btn" @click="confirm">{{$t('sure')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import AIExploit from '@/components/AIExploit'
export default {
  name: 'InputMore',
  components: {
    MultiInputTag: () => import('./MultiInputTag/index.vue'),
    AIExploit
  },
  props: {
    // 是否显示模糊查询
    showPreciseQuery: {
      type: Boolean,
      default: false
    },
    preciseQuery: {
      type: Boolean,
      default: false
    },
    limitInputType: { // 0不做限制 1不支持中文
      type: [Number, String],
      default: 0,
    },
    // 查询条件，非必填
    params: {
      type: [Object],
      default: () => {
        return {}
      }
    },
  },
  computed: {
  },
  data() {
    return {
      selected: [], // 已筛选条件
      tempData: [], // 缓存数据
      dialogVisible: false,
      title: '',
      id: '',
      dataItem: {},
      checkData: [],
      keyName: "", // 当前的key
      preciseQueryValue: false,
      defaultData: ()=>{
        return {type: 'or', value: ''}
      },
      firstKeyword: ""
    };
  },

  mounted() {
    
  },

  methods: {
    // 打开弹框
    open(data, key, id, type) {
      console.log(id);
      this.selected = JSON.parse(JSON.stringify(data)) 
      this.tempData = JSON.parse(JSON.stringify(data)) 
      this.keyName = type || ""
      if(!data.length) {
        this.selected = [this.defaultData()]
      }
      this.firstKeyword = this.selected[0].value
      this.preciseQueryValue = this.preciseQuery
      this.dialogVisible = true
      this.title = key
      this.id = id
      // 如果是产品关键词则展示AI拓词区域
      if(type==='productDescriptions') {
        this.$nextTick(()=>{
          this.$refs.AIExploit.init()
        })
      }
      this.handleBlur()
    },
    //添加/删除触发
    changeAIExploit(type, value) {
      if (type == "addwords") {
        this.selected.push({
          type: "or",
          value: value.value
        })
        let index = this.selected.length-1
        this.handleBlur(value, index)
      } else if (type == "delwords") {
        let index = this.selected.findIndex(e=>value.value==e.value)
        if (index >= 0) {
          this.handleDeleteData(value, index)
        }
      }
    },
    // 添加数据
    handleAddData() {
      if(this.selected.length<10) {
        this.selected.push(this.defaultData())
      } else {
        this.$message.warning(this.$i18.language("最多输入十个词组"))
      }
    },
    // 删除子数据
    handleDeleteData(item, index) {
      this.selected.splice(index, 1)
      if(!this.selected.length) {
        this.selected = [this.defaultData()]
      }
      this.handleBlur(item, index)
    },
    // 输入框失焦
    handleBlur(item, index) {
      this.checkData = this.selected.filter(item=>item.value.trim())
      // 处理翻译
      let modifyObj = this.tempData[index]
      if(modifyObj && modifyObj.hasOwnProperty("trans")) {
        item.trans = []
      }
      if(this.$refs.MultiInputTagMore) {
        this.$refs.MultiInputTagMore.checkedTagIndex = this.checkData.length
      }
      let first = this.selected[0].value
      // 如果是产品关键词则展示AI拓词区域
      if(this.keyName==='productDescriptions' && this.firstKeyword !== first) {
        this.$refs.AIExploit.init()
      }
      this.firstKeyword = this.selected[0].value
    },
    // 删除全部数据
    deleteAll() {
      this.selected = [this.defaultData()]
      this.checkData = []
    },
    // 关闭弹框
    close() {
      this.dialogVisible = false
    },
    // 删除子标签
    handleChangeTags(val) {
      this.selected = JSON.parse(JSON.stringify(val)) 
      if(!val.length) {
        this.selected = [this.defaultData()]
      }
    },
    // 切换模糊状态标识
    handleChangePrecise(val) {
      this.preciseQueryValue = val
    },
    // 确定修改
    confirm() {
      let data = this.checkData
      const newListLength = new Set(data.map(item=>item.value)).size;
      const listLength = data.length;
      if(newListLength!=listLength) {
        this.$message.warning(this.$i18.language("有重复筛选项，请重新输入"))
        return
      }
      // 如果是hs编码的弹框 仅支持纯数字
      let hscode_list = ['trade-search-hsCodes', 'trade-detail-search-hsCodes', 'company-search-hsCodes']
      if (hscode_list.includes(this.id)) {
        const res = data.some((e) => this.limitInputType == 1 && !/^[0-9]*$/.test(e.value))
        if (res) {
          return this.$message.warning(this.$i18.language('请填写数字的HS编码!'))
        }
      }
      this.$emit('changeData', data, this.preciseQueryValue);
      this.dialogVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.input-more-title {
  font-size: 14px;
  font-weight: 600;
  color: $--font-color-primary-6;
  line-height: 14px;
  margin-bottom: 16px;
}
.input-more-box {
  height: 50vh;
  overflow-y: auto;
  .input-more-item {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    .item-select {
      width: 25%;
      margin-right: 8px;
    }
  }
  .more-dialog-add-button {
    float: right;
    margin-right: 32px;
  }
}
.more-dialog-close-button {
  margin-left: 16px;
  cursor: pointer;
  height: 24px;
  width: 24px;
  font-size: $--font-size-large;
  line-height: 24px;
  color: $--color-primary-6;
} 
.search-value-desc {
  font-size: 14px;
  font-weight: 600;
  color: $--font-color-primary-6;
  line-height: 14px;
  margin-bottom: 13px;
}
.more-bottom-value {
  display: flex;
  .show-more-value {
    width: 100%;
  }
  
}
/deep/.AIExploit_wrap {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 16px;
}
</style>